import apiService from '../../../services/apiService';
import axios from 'axios';

const toISOLocal = (dateStr) => dateStr ? new Date(dateStr + 'T00:00:00').toISOString() : new Date().toISOString();

const CAMP_API = '/ykrestapi/CampChannel';
const CLASS_API = '/api/Class';
const PAYMENT_API = '/ykrestapi/PaymentChannel';
const COMMON_API = '/ykrestapi/CommonChannel';
const API_BASE_URL = process.env.REACT_APP_YK_API_BASE || 'http://localhost:5000/ykrestapi';

const EMPTY_CAMP_PAYLOAD = {
  Camp_Id: 0,
  Center_Id: 0,
  Camp_Name: '',
  Camp_Description: '',
  Camp_Fee: 0,
  Camp_Date_To: new Date().toISOString(),
  Camp_Date_From: new Date().toISOString(),
  Camp_Image_Url: '',
  Camp_Type: 'YV',
  App_Id: 5,
  Organization_Id: 0,
  Country_Desc: 'USA',
};

const ykVisitService = {
  getCenters: async (countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${CAMP_API}/GetCenterForRetreat`, {
        Country_Desc: countryDesc,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching visit centers:', error);
      throw error;
    }
  },

  getCampsByCenter: async (centerId, countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${CAMP_API}/GetCamp`, {
        ...EMPTY_CAMP_PAYLOAD,
        Center_Id: parseInt(centerId),
        Camp_Type: 'YV',
        App_Id: 5,
        Country_Desc: countryDesc,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching visit camps:', error);
      throw error;
    }
  },

  getUnregisteredStudents: async (userId, campId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/FetchUnRegisteredStudents`, {
        User_Id: parseInt(userId),
        Camp_Id: parseInt(campId),
        Camp_Type: 'YV',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching unregistered students:', error);
      throw error;
    }
  },

  getRegisteredStudents: async (userId, campId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/FetchRegisteredStudents`, {
        User_Id: parseInt(userId),
        Camp_Id: parseInt(campId),
        Camp_Type: 'YV',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching registered students:', error);
      throw error;
    }
  },

  addRegistration: async (userId, campId, studentId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/AddRetreatRegistration`, {
        Retreat_Registration_Id: 0,
        Student_Id: parseInt(studentId),
        Camp_Id: parseInt(campId),
        User_Id: parseInt(userId),
        Status: 'Active',
        CreatedBy: userId.toString(),
        Created: new Date().toISOString(),
        ModifiedBy: userId.toString(),
        Modified: new Date().toISOString(),
        retreatRegistrations: [],
      });
      return response.data;
    } catch (error) {
      console.error('Error adding registration:', error);
      throw error;
    }
  },

  addRegistrationDetail: async (registrationId, campId, studentId, visitRow) => {
    try {
      const response = await apiService.post(`${CAMP_API}/AddRetreatRegistrationDetail`, {
        Retreat_Registration_Details_Id: 0,
        Retreat_Registration_Id: parseInt(registrationId),
        Student_Id: parseInt(studentId),
        Camp_Id: parseInt(campId),
        Start_Date: visitRow.start_Date ? new Date(visitRow.start_Date + 'T00:00:00').toISOString() : new Date().toISOString(),
        End_Date: visitRow.end_Date ? new Date(visitRow.end_Date + 'T00:00:00').toISOString() : new Date().toISOString(),
        Is_Accommodation_Needed: visitRow.is_Accommodation_Needed || 'N',
        Is_Transport: visitRow.is_Transport || 'N',
        Registration_Fee: 0,
        Accommodation_Fees: 0,
        Visits: '0',
        No_Of_Days: '0',
        Status: 'Active',
        CreatedBy: '',
        Created: new Date().toISOString(),
        ModifiedBy: '',
        Modified: new Date().toISOString(),
      });
      return response.data;
    } catch (error) {
      console.error('Error adding registration detail:', error);
      throw error;
    }
  },

  fetchAttendeeDetails: async (campId, studentId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/FetchAttendeeDetails`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(studentId),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching attendee details:', error);
      throw error;
    }
  },

  getVisitRecordsForStudent: async (campId, studentId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/VisitRegisteredStudent`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(studentId),
        Camp_Type: 'YV',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching visit records:', error);
      throw error;
    }
  },

  deleteVisitRecord: async (campId, studentId, registrationId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/DeleteRecordOfvisiters`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(studentId),
        Retreat_Registration_Id: parseInt(registrationId),
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting visit record:', error);
      throw error;
    }
  },

  updateVisitDetail: async (detailData) => {
    try {
      const detailId =
        detailData.Retreat_Registration_Details_Id ||
        detailData.retreat_Registration_Details_Id ||
        detailData.id || 0;
      const response = await apiService.post(`${CAMP_API}/UpdateRetreatRegistrationDetail`, {
        Retreat_Registration_Details_Id: parseInt(detailId),
        Retreat_Registration_Id: parseInt(detailData.Retreat_Registration_Id || detailData.retreat_Registration_Id || 0),
        Student_Id: parseInt(detailData.student_Id || detailData.Student_Id || 0),
        Camp_Id: parseInt(detailData.camp_Id || detailData.Camp_Id || 0),
        Start_Date: toISOLocal(detailData.start_Date || detailData.Start_Date),
        End_Date: toISOLocal(detailData.end_Date || detailData.End_Date),
        Is_Accommodation_Needed: detailData.is_Accommodation_Needed || detailData.Is_Accommodation_Needed || 'N',
        Is_Transport: detailData.is_Transport || detailData.Is_Transport || 'N',
        Registration_Fee: detailData.registration_Fee || detailData.Registration_Fee || 0,
        Accommodation_Fees: detailData.accommodation_Fees || detailData.Accommodation_Fees || 0,
        ModifiedBy: '',
        Modified: new Date().toISOString(),
      });
      return response.data;
    } catch (error) {
      console.error('Error updating visit detail:', error);
      throw error;
    }
  },

  getCalculation: async (campId, studentId, registrationId) => {
    try {
      const response = await apiService.post(`${CAMP_API}/GetRetreatCalculation`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(studentId),
        Retreat_Registration_Id: parseInt(registrationId),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching calculation:', error);
      throw error;
    }
  },

  updatePaymentStatus: async (paymentData) => {
    try {
      const response = await apiService.post(`${CAMP_API}/UpdatePaymentStatus`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  },

  processPayment: async (paymentDetails) => {
    try {
      const isACH = paymentDetails.paymentType === 'ACH';
      const payload = {
        app: 'YKVisit',
        entity: paymentDetails.entity || 'RMS',
        paymentType: isACH ? 'ach' : 'cc',
        customerEmail: paymentDetails.userEmail,
        orderid: paymentDetails.campId?.toString() || '0',
        amount: paymentDetails.amount?.toString() || '0',
        description: `YK Visit Registration - ${paymentDetails.campName || ''} - $${paymentDetails.amount}`,
        customer: {
          firstName: paymentDetails.userFirstName || '',
          lastName: paymentDetails.userLastName || '',
          email: paymentDetails.userEmail,
          phone: paymentDetails.userPhone || '',
          company: 'string',
          notes: `YK Visit for ${paymentDetails.userFirstName} ${paymentDetails.userLastName}`,
          customerAccount: paymentDetails.userId?.toString() || 'string',
          shippingSameAsBilling: true,
          billingAddress: {
            streetAddress1: paymentDetails.streetAddress1 || '-',
            streetAddress2: paymentDetails.streetAddress2 || '-',
            city: paymentDetails.city || '-',
            stateCode: paymentDetails.state || '-',
            zipCode: paymentDetails.zipCode || '-',
            country: paymentDetails.country || 'USA',
          },
          shippingAddress: {
            streetAddress1: paymentDetails.streetAddress1 || '-',
            streetAddress2: paymentDetails.streetAddress2 || '-',
            city: paymentDetails.city || '-',
            stateCode: paymentDetails.state || '-',
            zipCode: paymentDetails.zipCode || '-',
            country: paymentDetails.country || 'USA',
          },
        },
        creditcard: isACH
          ? { creditCardNumber: 'string', expirationDate: 'string', issuer: 'string', billingZipCode: 'string', customerId: '', cvv: 'string' }
          : {
              creditCardNumber: paymentDetails.cardNumber,
              expirationDate: paymentDetails.expiryDate,
              issuer: 'string',
              billingZipCode: paymentDetails.zipCode || '-',
              customerId: '',
              cvv: paymentDetails.cvv,
            },
        ach: isACH
          ? {
              isCheckingAccount: paymentDetails.accountType === 'checking' ? 'Y' : 'N',
              routingNumber: paymentDetails.routingNumber,
              accountNumber: paymentDetails.accountNumber,
              bankName: paymentDetails.bankName || 'Financial Institution',
              customerId: '',
              isDefault: 'false',
            }
          : { isCheckingAccount: 'string', routingNumber: 'string', accountNumber: 'string', bankName: 'string', customerId: 'string', isDefault: 'string' },
        recurr: {
          paymentAmount: 'string', accountId: 'string', startDate: 'string',
          executionFrequencyType: 'string', executionFrequencyParameter: 'string',
          endDate: 'string', paymentSubType: 'string', invoiceNumber: 'string',
          firstPaymentAmount: 'string', firstPaymentDate: 'string', description: 'string',
        },
      };
      const response = await axios.post(`${API_BASE_URL}${PAYMENT_API.replace('/ykrestapi', '')}/AuthNetOneTimePayment`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      console.error('Payment processing error:', error?.response?.data || error);
      throw error;
    }
  },

  sendVisitConfirmationEmail: async (emailData) => {
    try {
      const studentsList = emailData.students && emailData.students.length > 0
        ? emailData.students.map(s => {
            const fn = s.student_First_Name || s.firstName || '';
            const ln = s.student_Last_Name || s.lastName || '';
            return `${fn} ${ln}`.trim();
          }).join(', ')
        : emailData.studentName || 'N/A';

      const emailParameter = {
        emailFrom: 'string',
        emailTo: emailData.toEmail || 'string',
        emailSubject: 'string',
        emailBody: 'string',
        attachment: 'Y',
        userPhoneNumber: emailData.userPhone || 'string',
        location: 'YKVisitRegistration',
        input: 'string',
        appContent: {
          userName: emailData.userName || 'string',
          programName: emailData.campName || 'string',
          appSchedule: emailData.visitDateRange || 'string',
          attendee: studentsList,
          studentNames: studentsList,
          date: emailData.transactionDate || new Date().toLocaleString(),
          orderType: 'Visit Registration',
          orderNo: String(emailData.registrationId || 'string'),
          paymentMode: 'Visit',
          amount: '0',
          email: emailData.toEmail || 'string',
          phone: emailData.userPhone || 'string',
          pickupPerson: emailData.userPhone || 'string',
          pickupPersonContact: emailData.userPhone || 'string',
          instructions: emailData.visitDateRange || 'string',
          itemData: studentsList,
          pickUpDate: emailData.userPhone || 'string',
          pickUpTime: emailData.visitDateRange || 'string',
          paymentType: 'Visit',
          billingAddress: 'string',
          address: 'string',
          pickupOrReceiver: emailData.visitDateRange || 'string',
          orderReady: '0',
          orderReadyLastLine: 'string',
          headingDate: emailData.visitDateRange || 'string',
          headingTime: emailData.userPhone || 'string',
          startDate: emailData.startDate || new Date().toISOString(),
          endDate: emailData.endDate || new Date().toISOString(),
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/MessageChannel/SendEmailMessage?appName=Visit&templateName=YKVisitRegistration&orgId=3`,
        emailParameter
      );
      return response.data;
    } catch (error) {
      console.error('Visit email error:', error?.response?.data || error);
      throw error;
    }
  },

  addVisitor: async (userId, studentData) => {
    try {
      const gender = studentData.gender === 'Male' ? 'M' : studentData.gender === 'Female' ? 'F' : '';
      const dob = studentData.dateOfBirth ? new Date(studentData.dateOfBirth).toISOString() : new Date().toISOString();
      const response = await apiService.post(`${CLASS_API}/AddStudent`, {
        studentId: 0, Student_Id: 0,
        classId: 0, Class_Id: 0,
        campId: 0, Camp_Id: 0,
        enrollmentId: 0, Enrollment_Id: 0,
        userId: parseInt(userId), User_id: parseInt(userId),
        lastName: studentData.lastName || '', Student_Last_Name: studentData.lastName || '',
        firstName: studentData.firstName || '', Student_First_Name: studentData.firstName || '',
        dateOfBirth: dob, Student_Date_Of_Birth: dob, Student_Date_Of_Birth1: '',
        gender, Student_Gender: gender,
        relationship: studentData.relationship || '', Student_Relationship_To_User: studentData.relationship || '',
        Student_Age: 0, Parent_Last_Name: '', Parent_First_Name: '',
        Student_Email: '', Student_Phone: '', Student_Address_Line1: '',
        Student_Address_Line2: '', Student_City: '', Student_Country: '',
        State_Id: 0, state_Id: 0, Student_Zip_Code: 0,
        Student_Internal_Comments: '', Student_Occupation: '', Status: 'Active', status: 'Active',
        createdBy: userId.toString(), Student_Age_Group_Id: 0, Is_Accommodation_Needed: '',
        Seva_Opportunity_Id: 0, RegisterSession_Count: 0, Selected_Session_Count: 0,
        Selected_To_Pay_Amt: 0, Extended_Amt: 0, Registered_Session_Count: 0,
        Registered_To_Pay_Amt: 0, User_Email: '', user_Email: '',
      });
      return response.data;
    } catch (error) {
      console.error('Error adding visitor:', error);
      throw error;
    }
  },

  updateVisitor: async (userId, studentId, studentData) => {
    try {
      const gender = studentData.gender === 'Male' ? 'M' : studentData.gender === 'Female' ? 'F' : '';
      const dob = studentData.dateOfBirth ? new Date(studentData.dateOfBirth).toISOString() : new Date().toISOString();
      const response = await apiService.post(`${CLASS_API}/UpdateStudent`, {
        studentId: parseInt(studentId), Student_Id: parseInt(studentId),
        classId: 0, Class_Id: 0,
        campId: 0, Camp_Id: 0,
        enrollmentId: 0, Enrollment_Id: 0,
        userId: parseInt(userId), User_id: parseInt(userId),
        lastName: studentData.lastName || '', Student_Last_Name: studentData.lastName || '',
        firstName: studentData.firstName || '', Student_First_Name: studentData.firstName || '',
        dateOfBirth: dob, Student_Date_Of_Birth: dob, Student_Date_Of_Birth1: '',
        gender, Student_Gender: gender,
        relationship: studentData.relationship || '', Student_Relationship_To_User: studentData.relationship || '',
        Student_Age: 0, Parent_Last_Name: '', Parent_First_Name: '',
        Student_Email: '', Student_Phone: '', Student_Address_Line1: '',
        Student_Address_Line2: '', Student_City: '', Student_Country: '',
        State_Id: 0, state_Id: 0, Student_Zip_Code: 0,
        Student_Internal_Comments: '', Student_Occupation: '', Status: 'Active', status: 'Active',
        createdBy: userId.toString(), Student_Age_Group_Id: 0, Is_Accommodation_Needed: '',
        Seva_Opportunity_Id: 0, RegisterSession_Count: 0, Selected_Session_Count: 0,
        Selected_To_Pay_Amt: 0, Extended_Amt: 0, Registered_Session_Count: 0,
        Registered_To_Pay_Amt: 0, User_Email: '', user_Email: '',
      });
      return response.data;
    } catch (error) {
      console.error('Error updating visitor:', error);
      throw error;
    }
  },

  getBankName: async (routingNumber) => {
    try {
      const response = await fetch(`${API_BASE_URL}${COMMON_API.replace('/ykrestapi', '')}/GetBankNameByRoutingNumber?routingNumber=${routingNumber}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        return data.bankName || data.name || data.institutionName || '';
      }
      return '';
    } catch (error) {
      console.error('Bank name lookup error:', error);
      return '';
    }
  },
};

export default ykVisitService;
